import React from "react";
import { cn } from "@/lib/utils";
import { useCapsLock } from "@/hooks/use-caps-lock";
import { Input } from "@/styles/ui/input";
import { Control } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/styles/ui/form";

interface LoginFormFieldProps {
  label: string;
  type: "email" | "password" | "text";
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  control?: Control<any>;
  name?: string;
  hideErrorMessage?: boolean;
}

export const LoginFormField: React.FC<LoginFormFieldProps> = ({
  label,
  type,
  placeholder,
  disabled = false,
  error = false,
  control,
  name,
  hideErrorMessage = false,
}) => {
  const capsLockOn = useCapsLock(type === "password");

  return (
    <FormField
      control={control}
      name={name!}
      render={({ field }) => (
        <FormItem className="w-full">
          <FormLabel className={cn("label-1-normal-medium text-primary")}>
            {label}
          </FormLabel>
          <FormControl>
            <Input
              placeholder={placeholder}
              type={type}
              className={cn(
                "h-9 px-3 py-1 rounded-rg",
                "label-1-normal-regular text-primary",
                "placeholder:text-neutral-400",
                "border-neutral-200 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]",
                "transition-all duration-200",
                "focus-visible:transition-none",
                error && ["border-red-500"],
                disabled && "opacity-50 cursor-not-allowed",
              )}
              {...field}
            />
          </FormControl>
          {capsLockOn && (
            <p role="alert" className="label-2-regular text-status-error">
              Caps Lock이 켜져 있습니다.
            </p>
          )}
          {!hideErrorMessage && (
            // <div className="w-full h-5">
            <FormMessage className="label-1-normal-regular text-[#DC2626]" />
            // </div>
          )}
        </FormItem>
      )}
    />
  );
  //   <div className={cn("w-full space-y-2", className)}>
  //     <Label
  //       htmlFor={inputId}
  //       className={cn(
  //         "label-1-normal-medium text-primary",
  //         error && "text-destructive",
  //       )}
  //     >
  //       {label}
  //     </Label>
  //     <div className="relative">
  //       <Input
  //         id={inputId}
  //         type={type}
  //         placeholder={placeholder}
  //         disabled={disabled}
  //         aria-invalid={error}
  //         aria-describedby={error ? errorId : undefined}
  //         autoComplete={autoComplete}
  //         className={cn(
  //           "h-9 px-3 py-1 rounded-rg",
  //           "label-1-normal-regular text-primary",
  //           "placeholder:text-neutral-400",
  //           "border-neutral-200 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]",
  //           "transition-all duration-200",
  //           "focus-visible:transition-none",
  //           error && ["border-red-500"],
  //           disabled && "opacity-50 cursor-not-allowed",
  //         )}
  //         {...register}
  //       />
  //     </div>
  //     {error && errorMessage && (
  //       <p
  //         id={errorId}
  //         className="label-2-medium text-destructive"
  //         role="alert"
  //       >
  //         {errorMessage}
  //       </p>
  //     )}
  //   </div>
  // );
};
